module.exports = __webpack_public_path__ + "static/media/AvatarPokoro.9281adc1.svg";